import React from "react";
import "./index.css";
import Box from "@mui/material/Box";
import { Typography, Button, Grid } from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";

type Props = {
  value: string | "";
  handleGoBack?: () => void;
  handleGoNext?: () => void;
  showNav?: boolean;
};

const HeadLine: React.FC<Props> = ({
  value,
  handleGoBack,
  handleGoNext,
  showNav = false,
}) => {
  return (
    <Grid container>
      {showNav && (
        <Grid size="grow">
          <Button
            variant="contained"
            disabled={!handleGoBack}
            aria-label="Go back"
            onClick={handleGoBack}
            className="btn-go-previous"
          >
            <ArrowBack sx={{ color: "#FFFFFF" }} />
          </Button>
        </Grid>
      )}
      <Box
        className="headline-typography"
        sx={{ margin: !handleGoBack ? "auto" : "" }}
      >
        <Typography align="center" color="primary" variant="h6">
          {value.toUpperCase()}
        </Typography>
      </Box>
      {showNav && (
        <Grid size="grow" className="btn-go-next">
          <Button
            variant="contained"
            disabled={!handleGoNext}
            aria-label="Go Next"
            onClick={handleGoNext}
          >
            <ArrowForward sx={{ color: "#FFFFFF" }} />
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default HeadLine;
